import dayjs, { Dayjs } from "dayjs";
import queryString from "query-string";
import useSWR from "swr";

import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import useEvent from "./useEvent";
import { useQuery } from "./useQuery";

interface OptionsType {
  code: string;
  name: string;
  type: string;
}

export interface HotelSearchConditionType {
  items: OptionsType[];
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}

const useHotelSearchCondition = (useWhere: "home" | "hotel") => {
  const query = useQuery<HotelSearchConditionType & { items: string }>();
  const navigate = useNavigate();

  const { data: searchType, mutate: changeSearchType } = useSWR<"booking" | "all">(
    "hotel-search-type"
  );

  const initCondition = useRef({
    items: query.items ? JSON.parse(query.items) : [],
    startDate: query.startDate || "",
    endDate: query.endDate || "",
  });

  const { data: condition = initCondition.current, mutate } =
    useSWR<HotelSearchConditionType>("hotel-search-condition");

  const getSearchParams = useEvent((value: HotelSearchConditionType) => {
    return queryString.stringify({
      items: JSON.stringify(value.items.slice(0, 3)),
      startDate: value.startDate ? dayjs(value.startDate).format("YYYY-MM-DD") : "",
      endDate: value.endDate ? dayjs(value.endDate).format("YYYY-MM-DD") : "",
    });
  });

  const changeCondition = (value: HotelSearchConditionType) => {
    mutate(value);

    if (useWhere === "hotel") {
      navigate(
        {
          pathname: "/hotels",
          search: getSearchParams(value),
        },
        { replace: true }
      );
    }
  };

  return {
    searchType,
    condition,
    changeSearchType,
    changeCondition,
    getSearchParams,
  };
};

export default useHotelSearchCondition;
